// Third Party
import { NextPage } from 'next';

// Utils
import { useSession } from 'next-auth/react';

// UI
import { PublicLayout } from '@layouts/public-layout';
import { Icon, IconNames } from '@components/icon';
import { routes } from '@routes';

const links = [
  {
    title: 'Search',
    description: 'Search Savvy to find your next vacation.',
    iconName: IconNames.MAGNIFYING_GLASS,
    href: routes.search,
  },
  {
    title: 'List your Properties',
    description: 'Get started today by listing your property.',
    iconName: IconNames.HOUSE_CHIMNEY,
    href: routes.list,
  },
];
/**
 * This page is visible to unauthenticated and authenticated users
 */
const Custom404: NextPage = () => {
  const { data: session, status } = useSession();

  return (
    <PublicLayout
      session={session}
      loadingSession={status === 'loading'}
      canonicalUrl={''}
      pageTitle="Page not found | Savvy"
      pageDescription="The page you are looking for could not be found."
    >
      <div className="max-w-2xl mx-auto py-16 sm:py-24 px-8 md:px-0">
        <div className="text-center">
          <p className="text-sm font-semibold text-primary-main uppercase tracking-wide">
            404 error
          </p>
          <h1 className="mt-2 text-4xl font-extrabold text-gray-dark tracking-tight sm:text-5xl">
            This page is on vacation and can’t be reached
          </h1>
          <p className="mt-2 text-lg text-gray-main">
            The page you are looking for could not be found.
          </p>
        </div>
        <div className="mt-12">
          <h2 className="text-sm font-semibold text-gray-main tracking-wide uppercase">
            Popular pages
          </h2>
          <ul
            role="list"
            className="mt-4 border-t border-b border-gray-light divide-y divide-gray-light"
          >
            {links.map((link, linkIdx) => (
              <li
                key={linkIdx}
                className="relative py-6 flex items-start space-x-4 hover:opacity-75"
              >
                <div className="flex-shrink-0">
                  <span className="flex items-center justify-center h-12 w-12 rounded-lg bg-indigo-50">
                    <Icon
                      name={link.iconName}
                      className="h-6 w-6 text-primary-main"
                      aria-hidden="true"
                    />
                  </span>
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="text-base font-medium text-gray-dark">
                    <span className="rounded-sm focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary-light">
                      <a href={link.href} className="focus:outline-none">
                        <span className="absolute inset-0" aria-hidden="true" />
                        {link.title}
                      </a>
                    </span>
                  </h3>
                  <p className="text-base text-gray-main">{link.description}</p>
                </div>
                <div className="flex-shrink-0 self-center">
                  <Icon
                    name={IconNames.CHEVRON_RIGHT}
                    className="h-5 w-5 text-gray-main"
                    aria-hidden="true"
                  />
                </div>
              </li>
            ))}
          </ul>
          <div className="mt-8">
            <a
              href={routes.home}
              className="text-base font-medium text-primary-main hover:text-primary-light"
            >
              Or go back home<span aria-hidden="true"> &rarr;</span>
            </a>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
};

export default Custom404;
